<div>
  <div class="sidebar sidebar-light sidebar-main sidebar-expand" [ngClass]="{'collapsed': !isSidebarExpanded}">

    <!-- Sidebar content -->
    <div class="sidebar-content" [ngClass]="{'collapsed': !isSidebarExpanded}">

      <div class="card card-sidebar-mobile mb-0">
        <ul class="nav nav-sidebar mb-5">

          <li class="nav-item">
            <a routerLink="/" [routerLinkActive]="['active']" [routerLinkActiveOptions]="{ exact: true }" class="nav-link accesibility-focus"
              [matTooltip]="!isSidebarExpanded ? 'Home' : ''" matTooltipPosition="right" matTooltipShowDelay="500" matTooltipHideDelay="200">
              <img class="hub-icon" src="/assets/images/icons/Home.svg" />
              <span class="link-title">Home</span>
            </a>
          </li>

          <li class="nav-item">
            <a routerLink="/user" [routerLinkActive]="['active']" [routerLinkActiveOptions]="{ exact: true }" class="nav-link accesibility-focus"
              [matTooltip]="!isSidebarExpanded ? 'Your Work' : ''" matTooltipPosition="right" matTooltipShowDelay="500" matTooltipHideDelay="200">
              <img class="hub-icon" src="/assets/images/icons/Work.svg" />
              <span class="link-title">Your Work</span>
            </a>
          </li>

          <li class="nav-item">
            <a routerLink="/portfolio" [routerLinkActive]="['active']" [routerLinkActiveOptions]="{ exact: true }" class="nav-link accesibility-focus"
              [matTooltip]="!isSidebarExpanded ? 'Search Portfolio' : ''" matTooltipPosition="right" matTooltipShowDelay="500" matTooltipHideDelay="200">
              <img class="hub-icon" src="/assets/images/icons/Portfolio.svg" />
              <span class="link-title">Search Portfolio</span>
            </a>
          </li>

          <li class="nav-item">
            <a href="#" (click)="requestHubRecordCreateDialog($event)" class="nav-link accesibility-focus"
              [matTooltip]="!isSidebarExpanded ? 'Create new Record' : ''" matTooltipPosition="right" matTooltipShowDelay="500" matTooltipHideDelay="200">
              <img class="hub-icon" src="/assets/images/icons/Create.svg" />
              <span class="link-title">Create new Record</span>
            </a>
          </li>

          <li class="nav-item">
            <a routerLink="/collections" class="nav-link accesibility-focus" [routerLinkActive]="['active']" [routerLinkActiveOptions]="{ exact: true }"
              [matTooltip]="!isSidebarExpanded ? 'Collections' : ''" matTooltipPosition="right" matTooltipShowDelay="500" matTooltipHideDelay="200">
              <img class="hub-icon" src="/assets/images/icons/Collections.svg" />
              <span class="link-title">Collections</span>
            </a>
          </li>

          <li class="nav-item">
            <a routerLink="/dashboards" class="nav-link accesibility-focus" [routerLinkActive]="['active']" [routerLinkActiveOptions]="{ exact: true }"
              [matTooltip]="!isSidebarExpanded ? 'Dashboards' : ''" matTooltipPosition="right" matTooltipShowDelay="500" matTooltipHideDelay="200">
              <img class="hub-icon" src="/assets/images/icons/Dashboard.svg" />
              <span class="link-title">Dashboards</span>
            </a>
          </li>

          @if (shouldAdminMenuShow()) {
            <li class="nav-item">
                <a routerLink="/administration" class="nav-link accesibility-focus" [routerLinkActive]="['active']" [routerLinkActiveOptions]="{ exact: true }"
                [matTooltip]="!isSidebarExpanded ? 'Administration' : ''" matTooltipPosition="right" matTooltipShowDelay="500" matTooltipHideDelay="200">
                <img class="hub-icon" src="/assets/images/icons/Admin.svg" />
                <span class="link-title">Administration</span>
                </a>
            </li>
          }

          @if (isSidebarExpanded) {
            <li class="nav-item">
                <a target="_blank" href="https://thenatureconservancy462.sharepoint.com/sites/Organization/news/SitePages/Celebrating-75-Years-of-The-Nature-Conservancy.aspx">
                    <img src="/assets/images/75_years.svg" />
                </a>
            </li>
          }
          @else {
            <li class="nav-item">
                <a target="_blank" href="https://thenatureconservancy462.sharepoint.com/sites/Organization/news/SitePages/Celebrating-75-Years-of-The-Nature-Conservancy.aspx">
                    <img src="/assets/images/75th_alone.png" style="max-width: 100%;" />
                </a>
            </li>
          }

        </ul>
      </div>
    </div>

  </div>
</div>
